import {EAuthRole} from "../types/auth";

function fn(role: EAuthRole): boolean {
    return role === EAuthRole.ADMIN;
}

export default fn;
